module.exports = __webpack_public_path__ + "img/STelligence-logo-full-size.92778723.png";